import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getBlogByID } from "./BlogApi";
import ComponentTitle from "../../../Common/ComponentTitle";
import { Card, Image } from "antd";
import { ExtractDate, ExtractTime } from "../../../utils";
import { FaArrowLeft } from "react-icons/fa6";
export default function PreviewBlog() {
  const [blogData, setblogData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [descriptionData, setDescriptionData] = useState("");
  const navigate = useNavigate();

  const location = useLocation();
  const id = location.state?.id;
  console.log(id, "id");
  const gridStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    padding: "12px",
    gap: "10px",
    border: "none",
  };
  useEffect(() => {
    setIsLoading(true);
    getBlogByID(`?blogId=${id}`)
      .then((response) => {
        if (response.data.status) {
          setIsLoading(false);
          setblogData(response.data.data);
          setDescriptionData(response.data.data?.description);
        }
      })
      .catch((err) => {
        console.log("error", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [id]);
  console.log(blogData.description);
  const customDate = new Date(blogData.createdAt).toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
  const InnerHTML = ({ html }) => (
    <div dangerouslySetInnerHTML={{ __html: html }} />
  );

  return (
    <>
      <div>
        <title>{blogData?.title || "Blog Details"}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        {blogData?.metaTags?.map((meta, index) => (
          <meta key={index} name={meta.keywords} content={meta.description} />
        ))}
      </div>
      <div className="pt-28 px-4 md:px-10 lg:px-[20%] py-10 bg-white">
        <img
          src={`${process.env.REACT_APP_IMAGE_URL}${blogData.coverImage}`}
          alt={blogData?.title}
          className="object-cover w-full h-[250px] sm:h-[350px] md:h-[450px] rounded-lg"
        />
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mt-6">
          {blogData?.title}
        </h1>
        <p className="text-sm sm:text-lg text-gray-700 mt-2">
          <strong>Published on:</strong>{" "}
          <span className="text-blue-600">
            {ExtractDate(blogData.createdAt)}.{ExtractTime(blogData.createdAt)}
          </span>
        </p>
        <p
          className="text-sm sm:text-lg text-gray-700 mt-4"
          dangerouslySetInnerHTML={{ __html: blogData?.description }}
        ></p>
        <p
          onClick={() => navigate("/blog/blogData")}
          className="mt-6 block text-blue-600 hover:underline text-sm sm:text-base cursor-pointer"
        >
          ← Back to Blogs
        </p>
      </div>
    </>
    // <div>
    //   <ComponentTitle title="Blog Preview" />
    //   <div className="flex items-end justify-end mb-4">
    //     <p
    //       onClick={() => navigate("/blog/blogData")}
    //       className="text-blue-600  cursor-pointer  text-sm font-semibold  flex underline underline-offset-4"
    //     >
    //       ← Show All Blogs
    //     </p>
    //   </div>
    //   <div className="bg-white p-6 rounded-md shadow-sm border border-rgbaprimary9">
    //     {/* Cover Image */}
    //     <Image
    //       src={`${process.env.REACT_APP_IMAGE_URL}${blogData.coverImage}`}
    //       alt="Cover"
    //       width="100%"
    //       height={280}
    //       style={{ objectFit: "contain" }}
    //       preview={false}
    //     />

    //     {/* Title and Info */}
    //     <div className="  p-4">
    //       <div className="mt-6">
    //         <h1 className="text-2xl font-semibold text-rgbaprimary9 font-poppins underline underline-offset-4">
    //           {blogData.title}
    //         </h1>
    //         <p className="text-sm text-gray-600 font-poppins mt-2">
    //           {blogData.subtitle}
    //         </p>
    //         <p className="text-sm text-gray-500 font-poppins mt-2">
    //           <strong>Slug:</strong> {blogData.slug}
    //         </p>
    //         <p className="text-sm text-gray-500 font-poppins mt-1">
    //           <strong>Category Slug:</strong> {blogData.categorySlug}
    //         </p>
    //       </div>
    //       <div className="mt-6 text-sm text-gray-800 font-poppins">
    //         <p className="text-sm text-gray-500 font-poppins mt-1 mb-2">
    //           <strong>Description:</strong>
    //         </p>
    //         {/* <div className="h-80 overflow-scroll border border-gray-300 p-2"> */}
    //         <InnerHTML html={blogData.description} />
    //         {/* </div> */}
    //       </div>
    //       {/* Meta Tags */}
    //       <div className="mt-6 font-poppins">
    //         <Card title="Meta Tags">
    //           {blogData?.metaTags?.map((tag, index) => (
    //             <div key={index} className="grid grid-cols-2 border-b p-2">
    //               <div className="font-semibold text-primary uppercase">
    //                 {tag.keywords}
    //               </div>
    //               <div className="text-gray-700">{tag.description}</div>
    //             </div>
    //           ))}
    //         </Card>
    //       </div>
    //       {/* Created At */}
    //       <div className="mt-6 bg-rgbaprimary1 p-3 rounded-md text-sm text-gray-700 font-poppins text-end">
    //         <p className="text-sm text-gray-600 underline underline-offset-2">
    //           <strong>Published on:</strong> {customDate}
    //         </p>
    //       </div>
    //     </div>

    //     {/* Blog Description */}
    //   </div>
    // </div>
  );
}
